import { PropsWithChildren } from 'react';

import { Ellipsis } from '../Ellipsis/Ellipsis';
import './TableAddress.css';

export function TableAddressSecond({ children }: PropsWithChildren) {
  return <Ellipsis className="TableAddressSecond">{children}</Ellipsis>;
}
